import { colors } from '@theme/colors';

import { alpha } from '@mui/material/styles';

const CUSTOM_SHADOW_COLOR = alpha(colors.grey600, 0.24);

export const themeCustomShadows = {
  z1: `0 1px 2px 0 ${CUSTOM_SHADOW_COLOR}`,
  z8: `0 8px 16px 0 ${CUSTOM_SHADOW_COLOR}`,
  z12: `0 12px 24px 0 ${CUSTOM_SHADOW_COLOR} 0 10px 20px 0 ${CUSTOM_SHADOW_COLOR}`,
  z16: `0 0 3px 0 ${CUSTOM_SHADOW_COLOR} 0 14px 28px -5px ${CUSTOM_SHADOW_COLOR}`,
  z20: `0 0 3px 0 ${CUSTOM_SHADOW_COLOR} 0 18px 36px -5px ${CUSTOM_SHADOW_COLOR}`,
  z24: `0 0 6px 0 ${CUSTOM_SHADOW_COLOR} 0 21px 44px 0 ${CUSTOM_SHADOW_COLOR}`,

  primary: `0px 12px 14px 0px ${alpha(colors.primaryMain, 0.3)}`,
  secondary: `0px 12px 14px 0px ${alpha(colors.secondaryMain, 0.3)}`,
  orange: `0px 12px 14px 0px ${alpha(colors.orangeMain, 0.3)}`,
  success: `0px 12px 14px 0px ${alpha(colors.successMain, 0.3)}`,
  warning: `0px 12px 14px 0px ${alpha(colors.warningMain, 0.3)}`,
  error: `0px 12px 14px 0px ${alpha(colors.errorMain, 0.3)}`,
};
